import { useAppSelector } from '../store/hooks/hooks';

/**
 * Use this hook to determine whether you are in the SSR or the CSR context.
 */
export default function useIsClientSide(): boolean {
    return useAppSelector((state) => !state.renderContext.isServerSideRendering);
}
